import React, {useEffect, useState} from "react";
import {Form, Button, Col, DatePicker, Modal, notification, Row} from "antd";
import '../../../components/modals/modals.css';
import InputField from "../../input-field";
import {orderDeliveryService} from "../../../services";
import i18n from "i18next";

export default function ModalCreateOrderDocs({id, num, isShow, onCloseModal}) {
  const [fieldsErrors, setFieldsErrors] = useState([]);
  const [invoiceNumber, setInvoiceNumber] = useState(null);
  const [invoiceDate, setInvoiceDate] = useState(null);
  const [actNumber, setActNumber] = useState(null);
  const [actDate, setActDate] = useState(null);
  const [waybillsNumbers, setWaybillsNumbers] = useState("");
  const [isValidated, setIsValidated] = useState(false);

  const bigButtonStyle = {
    width: '116px',
    height: '40px',
    background: '#1CAA53',
    borderRadius: '10px',
    borderColor: "#1CAA53"
  };

  const getFieldErrors = (nameField) => {
    return (fieldsErrors && typeof fieldsErrors[nameField] !== "undefined")
      ? fieldsErrors[nameField]
      : null;
  };

  const clearForm = () => {
    setInvoiceNumber(null);
    setInvoiceDate(null);
    setActNumber(null);
    setActDate(null);
    setWaybillsNumbers('');
  }

  const validateFormData = () => {
    let errors = {};

    if (invoiceNumber === null || invoiceNumber === "") {
      errors = {
        ...errors,
        invoiceNumber: [i18n.t('modals.modalCreateOrderDocs.errors.invoiceNumber')]
      }
    }

    if (invoiceDate === null) {
      errors = {
        ...errors,
        invoiceDate: [i18n.t('modals.modalCreateOrderDocs.errors.invoiceDate')]
      }
    }

    if (actNumber === null || actNumber === "") {
      errors = {
        ...errors,
        actNumber: [i18n.t('modals.modalCreateOrderDocs.errors.actNumber')]
      }
    }

    if (actDate === null) {
      errors = {
        ...errors,
        actDate: [i18n.t('modals.modalCreateOrderDocs.errors.actDate')]
      }
    }

    // if (!waybillsNumbers.length) {
    //   errors = {
    //     ...errors,
    //     waybillsNumbers: ["Введите номера ТН"]
    //   }
    // }

    if (Object.keys(errors).length !== 0) {
      setFieldsErrors(errors);
      setIsValidated(false);
    } else {
      setFieldsErrors(null);
      setIsValidated(true);
    }
  };

  useEffect(() => {
    if (
      invoiceNumber !== null &&
      // waybillsNumbers !== null &&
      invoiceDate !== null &&
      actNumber !== null &&
      actDate !== null
    ) {
      validateFormData();
    }
  }, [invoiceNumber, waybillsNumbers, invoiceDate, actNumber, actDate]);

  const onClickCreateDocs = (e) => {
    e.preventDefault();

    orderDeliveryService
      .createInvoice(id, Number(invoiceNumber), invoiceDate, waybillsNumbers)
      .then((response) => {
        notification.success({
          message: i18n.t('components.notification.titles.createInvoice'),
          description: response.message,
        });
      })
      .then(() => {
        orderDeliveryService
          .createAct(id, Number(actNumber), actDate, waybillsNumbers)
          .then((response) => {
            notification.success({
              message: i18n.t('components.notification.titles.createAct'),
              description: response.message,
            });
            setFieldsErrors(null);
            onCloseModal();
            clearForm();
          })
          .catch((error) => {
            notification.error({
              message: i18n.t('components.notification.titles.createAct'),
              description: error,
            });
          });
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('components.notification.titles.createInvoice'),
          description: error,
        });
      });

  };

  return <Modal title={i18n.t('modals.modalCreateOrderDocs.title', {num: num})}
                cancelText={i18n.t('main.buttons.close')}
                className="modal-window"
                align={null}
                visible={isShow}
                onCancel={onCloseModal}
                footer={<div>
                  <Button type={"primary"} style={bigButtonStyle}
                          disabled={!isValidated}
                          onClick={onClickCreateDocs}>{i18n.t('main.buttons.create')}</Button>
                </div>}
  >
    <Row gutter={16}>
      <Col md={24} lg={12}>
        <InputField type={"number"}
                    label={i18n.t('modals.modalCreateOrderDocs.fields.invoiceNumber.title')}
                    name={"invoiceNumber"}
                    getFieldErrors={getFieldErrors}
                    setValue={value => {
                      setInvoiceNumber(value);
                    }}
                    value={invoiceNumber}
                    placeholder={i18n.t('modals.modalCreateOrderDocs.fields.invoiceNumber.placeholder')}
        />
      </Col>
      <Col md={24} lg={12}>
        <span className="form-field-label">{i18n.t('modals.modalCreateOrderDocs.fields.invoiceDate.title')}</span>
        <Form.Item validateStatus={fieldsErrors && typeof fieldsErrors.date !== "undefined" ? `error` : ""}
                   help={fieldsErrors && typeof fieldsErrors.date !== "undefined" ? fieldsErrors.date : ""}>
          <DatePicker style={{width: "100%"}}
                      format="DD.MM.YYYY"
                      size="large"
                      name="invoiceDate"
                      allowClear={false}
                      width={"100%"}
                      onChange={(date) => {
                        setInvoiceDate(date);
                      }}
          />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={16}>
      <Col md={24} lg={12}>
        <InputField type={"number"}
                    label={i18n.t('modals.modalCreateOrderDocs.fields.actNumber.title')}
                    name={"actNumber"}
                    getFieldErrors={getFieldErrors}
                    setValue={setActNumber}
                    value={actNumber}
                    placeholder={i18n.t('modals.modalCreateOrderDocs.fields.actNumber.placeholder')}
        />
      </Col>
      <Col md={24} lg={12}>
        <span className="form-field-label">{i18n.t('modals.modalCreateOrderDocs.fields.actDate.title')}</span>
        <Form.Item validateStatus={fieldsErrors && typeof fieldsErrors.date !== "undefined" ? `error` : ""}
                   help={fieldsErrors && typeof fieldsErrors.date !== "undefined" ? fieldsErrors.date : ""}>
          <DatePicker style={{width: "100%"}}
                      format="DD.MM.YYYY"
                      size="large"
                      name="actDate"
                      allowClear={false}
                      width={"100%"}
                      onChange={(date) => {
                        setActDate(date);
                      }}
          />
        </Form.Item>
      </Col>
    </Row>
    {/*<Row gutter={16}>*/}
    {/*  <Col>*/}
    {/*    <span className="form-field-label">{"Номера ТН"}</span>*/}
    {/*    <Form.Item validateStatus={fieldsErrors && typeof fieldsErrors.waybillsNumbers !== "undefined" ? `error` : ""}*/}
    {/*               help={fieldsErrors && typeof fieldsErrors.waybillsNumbers !== "undefined" ? fieldsErrors.waybillsNumbers : ""}>*/}
    {/*      <Input.TextArea rows={4}*/}
    {/*                      name={"waybillsNumbers"}*/}
    {/*                      placeholder={"Введите номера ТН через запятую"}*/}
    {/*                      allowClear*/}
    {/*                      defaultValue={""}*/}
    {/*                      onChange={(e) => {*/}
    {/*                        setWaybillsNumbers(e.target.value)*/}
    {/*                      }}*/}
    {/*                      value={waybillsNumbers}*/}
    {/*      />*/}
    {/*    </Form.Item>*/}
    {/*  </Col>*/}
    {/*</Row>*/}
  </Modal>
}
